import {useEffect, useState} from 'react';
import {
  getStaticAssetUrl,
  StaticAssetType,
} from './shared/utils/getStaticAssetUrl';

export default function useIsLoadedIniPlayerScript() {
  const [isLoadedIniPlayer, setIsLoadedIniPlayer] = useState(false);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = getStaticAssetUrl('ini-player.js', StaticAssetType.Js);
    script.onload = () => setIsLoadedIniPlayer(true);
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return isLoadedIniPlayer;
}
